module.exports = __webpack_public_path__ + "img/shining-nikki.ac2fd33.jpg";